.container {
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 16px;
  overflow: hidden;
}

.completedIcon {
  position: absolute;
  top: -5px;
  right: -5px;
}

.completedRewardItem {
  background: linear-gradient(90deg, #5a6f24, #758f2c);
}

.clickable {
  cursor: pointer;
}

/* The ring is the only thing that tells a keyboard user which car they are on. Fixed white,
   like the deal tabs' ring, and drawn just outside the card on the page's dark background: a
   car the Tab key reaches invisibly is no better reached than one it never reaches at all. */
.clickable:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

.divider {
  width: 1px;
  background: #FFFFFF3D;
  height: 10px;
}

.amountWrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 6px;
}
